import { visit } from "unist-util-visit";

type HastNode = any;

const ACCENT_PATTERN = /==([\s\S]+?)==/g;

export default function rehypeAccentColor() {
    return (tree: HastNode) => {
        visit(tree, "text", (node: HastNode, index: number | null | undefined, parent: HastNode | null | undefined) => {
            if (!parent || typeof index !== "number") return;

            const value = typeof node.value === "string" ? node.value : "";
            if (!value) return;

            ACCENT_PATTERN.lastIndex = 0;
            if (!ACCENT_PATTERN.test(value)) return;

            ACCENT_PATTERN.lastIndex = 0;

            const newChildren: HastNode[] = [];
            let lastIndex = 0;
            let match: RegExpExecArray | null;

            while ((match = ACCENT_PATTERN.exec(value)) !== null) {
                const matchIndex = match.index ?? 0;
                const fullMatch = match[0] ?? "";
                const innerText = match[1] ?? "";

                if (matchIndex > lastIndex) {
                    newChildren.push({ type: "text", value: value.slice(lastIndex, matchIndex) });
                }

                newChildren.push({
                    type: "element",
                    tagName: "span",
                    properties: { className: ["text-green-500", "font-bold"] },
                    children: [{ type: "text", value: innerText }]
                });

                lastIndex = matchIndex + fullMatch.length;
            }

            if (lastIndex < value.length) {
                newChildren.push({ type: "text", value: value.slice(lastIndex) });
            }

            if (newChildren.length === 0) return;

            parent.children.splice(index, 1, ...newChildren);
        });
    };
}
